import { date, object, string } from 'yup'

const MAX_LENGTH = 30

const MIN_LENGTH = 2

export const checkAddCloseCircle = object({
  lastName: string().required().max(MAX_LENGTH).min(MIN_LENGTH),
  firstName: string().required().max(MAX_LENGTH).min(MIN_LENGTH),
  middleName: string().default('-').max(MAX_LENGTH),
  citizenship: string().required(),
  passport: string().required(),
  gender: string().required(),
  dateOfBirth: date().required(),
  serialDocuments: string().required(),
  documentExpirationDate: date().required(),
})
